// extracted by mini-css-extract-plugin
export default {"infoSection":"InfoSection_infoSection__WQfxO"};